<c-input-group class="flex-nowrap p-2">
  <span class="input-group-text">
    <i [ngClass]="`${iconsStyle} ${iconSize} ${icons.user}`"></i>
  </span>
  <input
    type="text"
    required
    class="form-control"
    autocomplete="on"
    aria-describedby="username-sizing-sm"
    [placeholder]="placeholder | translate"
    [(ngModel)]="value"
    (input)="onInput(getInputValue($event))"
    (keyup)="onKeyup($event)"
  />
</c-input-group>
